module.exports = __webpack_public_path__ + "img/box-community.5a644b21.jpg";